import { ContentfulUnifiedLandingPage } from 'ContentfulDefaults/types/unifiedLanding';

export const unifiedLanding: {
  unified_landing_page: ContentfulUnifiedLandingPage;
} = {
  unified_landing_page: {
    open_enrollment_bar_days_left_text: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
                {
                  type: 'bold',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: ' days',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' left to enroll!',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    open_enrollment_bar_before_oe_text: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
                {
                  type: 'bold',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: ' days',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' until Open Enrollment begins!',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    choose_experience_modal: {
      contentful_name: '[default] Unified Landing Choose Experience Modal',
      title: 'Choose your {x} experience',
      option1_bullets: [
        'An audio-led experience',
        'In-depth education on all of your options',
        'Closed captioning available',
      ],
      option2_bullets: [
        'A text-based experience',
        'A brief overview of your benefits',
        'Includes a family plan comparison tool',
      ],
      button: 'Continue',
      spanish_support_disclaimer: 'Solo disponible en inglés',
      reviewer_note:
        'Para los revisores: El Modo de Revisión no está disponible en la experiencia de audio. Para usar el Modo de Revisión, por favor seleccione la opción "Breve resumen de sus beneficios" — ¡y no olvide probar la experiencia de audio también!',
    },
    hide_open_enrollment_bar: false,
    open_enrollment_bar_start_date: '2023-07-03T00:00:00-04:00',
    open_enrollment_bar_end_date: '2023-07-16T00:00:00-04:00',
    open_enrollment_bar_enroll_by_text: 'Inscríbase para el {date}.',
    plan_year_start_date: '2024-01-01T00:00:00-04:00',
    plan_year_end_date: '2024-12-31T00:00:00-04:00',
    carousel_header: 'Más formas de convertirse en un experto en beneficios',
    carousel_medical_services_text: 'Cómo comparar precios de servicios médicos.',
    carousel_prescriptions_text: 'Gaste menos en recetas regulares',
    carousel_mental_health_text: 'Utilice los beneficios para apoyar su salud mental.',
    carousel_tax_advantaged_text: 'El poder de las cuentas con ventajas fiscales.',
    carousel_view_all_button: 'Ver todo',
    hero: {
      contentful_name: '[default] Unified Landing Hero',
      title: '{x}puede ayudarle a elegir un plan médico rápidamente.',
      cta_button: 'Empecemos',
      continue_as_guest_button: 'Comience como visitante',
      login_or_signup_button: 'Iniciar sesión o registrarse',
      login_signup_description: '¡Guarde su progreso, obtenga consejos adicionales y más!',
      continue_as_guest_description: 'Sin guardar su progreso.',
      authenticated_header: '¡Bienvenido, {x}!',
      title_primary: 'Elige sus mejores beneficios',
      title_trailing_emphasis: 'con confianza',
      subheader:
        'ALEX le ayuda a encontrar los planes adecuados para sus necesidades y maximizar sus ahorros, sin necesidad de hacer cálculos.',
      uat_no_login_header: 'Para tener la mejor experiencia de revisión, por favor no inicie sesión.',
      uat_no_login_message:
        'Probar múltiples escenarios mientras está conectado puede resultar en información contradictoria. Si inicia sesión y algo no está bien, cierre la sesión e inténtelo de nuevo.',
      alex_explanation_header: 'Cómo trabaja ALEX',
      alex_profile_explanation:
        'Responda algunas preguntas sobre su presupuesto y necesidades de atención médica, como visitas al médico y recetas.',
      alex_plan_selection_explanation:
        'Entonces, ALEX le ayuda a comparar planes, para que pueda inscribirse con confianza en la mejor cobertura disponible al menor costo.',
      secondary_cta_header_primary: '¿Listo para hablar',
      secondary_cta_header_trailing_emphasis: 'con Alex',
      secondary_cta_header_final_punctuation: '?',
      secondary_cta_message:
        'ALEX le brinda los conocimientos que necesita para elegir sus mejores beneficios, para que no tenga que preguntarse si tiene la cobertura que necesita.',
      marketing_carousel_quotes: [
        {
          startText:
            'Aprender sobre el seguro puede ser abrumador, pero esto fue una forma útil de entenderlo todo.”',
          quoteAuthor: 'Damian',
        },
        {
          startText:
            'ALEX fue la herramienta más útil. Nunca antes me habían explicado mis beneficios con tanta claridad.”',
          quoteAuthor: 'Priya',
        },
        {
          startText: 'ALEX les da recomendaciones de beneficios a la mayoría de las personas en',
          bigText: '12 minutos',
          endText: 'o menos',
        },
        {
          startText: 'Esto hizo que elegir mi plan fuera extremadamente fácil y claro.”',
          quoteAuthor: 'Sam',
        },
        {
          bigText: '85%',
          endText: 'de las personas entienden mejor sus beneficios después de hablar con ALEX',
        },
        {
          startText: 'Me gustó la sensación de tener a alguien con quien hablar sobre esto.”',
          quoteAuthor: 'Marcie',
        },
        {
          startText: 'Más de',
          bigText: 'un millón',
          endText: 'de personas confiaron en ALEX para ayudarlas a elegir sus beneficios en 2024',
        },
      ],
    },
    alert_banner_enabled: false,
    alert_banner_content: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Modal content goes here',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    terms_and_policy_disclaimer: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'By clicking "Help Me Choose", you  agree to the ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [{ type: 'bold' }],
              value: 'Terms of Service',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '\u00a0and ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [{ type: 'bold' }],
              value: 'Privacy Policy',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [{ type: 'code' }],
              value: '.',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    ie_disclaimer: {
      contentful_name: '[DEFAULT] IE Disclaimer',
      header: "You're using an outdated browser!",
      text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  "We can't promise the best experience while using the site on your browser. Please use an updated browser like Google Chrome, Firefox, Edge, or Safari.",
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      color: 'red',
      icon: 'X',
    },
    show_custom_disclaimer: 'show custom disclaimer',
    custom_landing_disclaimer_button_text: 'custom disclaimer button text',
    custom_landing_disclaimer_modal_title: '"Notice"',
    custom_landing_disclaimer_modal: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Modal content goes here',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    custom_landing_disclaimer: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: 'Disclaimer text goes here',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    open_enrollment_bar_days_left_ending_soon_text: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          data: {},
          content: [
            {
              nodeType: 'text',
              value: 'Only ',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '{x}',
              marks: [
                {
                  type: 'code',
                },
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' days',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: ' left to enroll!',
              marks: [],
              data: {},
            },
          ],
        },
      ],
    },
    footer: {
      contentful_name: '[default] Unified Landing Footer',
      disclaimer: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'ALEX provides a summary of your benefits and is accurate to the best of our knowledge. This is not an application for enrollment. By clicking "Login or signup" you agree to the ',
                nodeType: 'text',
              },
              {
                data: {
                  uri: 'https://www.jellyvision.com/tos/',
                },
                content: [
                  {
                    data: {},
                    marks: [
                      {
                        type: 'bold',
                      },
                    ],
                    value: 'Terms of Service',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'hyperlink',
              },
              {
                data: {},
                marks: [],
                value: ' and ',
                nodeType: 'text',
              },
              {
                data: {
                  uri: 'https://www.jellyvision.com/privacy/',
                },
                content: [
                  {
                    data: {},
                    marks: [
                      {
                        type: 'bold',
                      },
                    ],
                    value: 'Privacy Policy',
                    nodeType: 'text',
                  },
                ],
                nodeType: 'hyperlink',
              },
              {
                data: {},
                marks: [],
                value: '.',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      copyright: '© 2008–{x} The Jellyvision Lab, Inc. All rights reserved.',
      do_not_sell_text: 'No Vendas Mi Informacion',
    },
    contentful_name: '[testdan1] Unified Landing Page',
    medicare_callout: {
      contentful_name: '[default] Unified Landing Medicare Callout',
      tag: 'New',
      text: '{x} can now help you with Medicare!',
      cta_button: 'Learn More About Medicare',
      cta_button_v2: 'Obtenga más información',
      text_primary: '¿Tiene preguntas sobre Medicare?',
      text_secondary: 'ALEX también puede ayudar con eso.',
    },
    text_note: {
      short_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'text note short text',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      long_text: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: 'long text text note',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      button_text: 'Leer más',
    },
  },
};

export default unifiedLanding;
